<form [formGroup]="targetForm">
    <section class="sideRight-body">
        <div class="rde-container-fluid">
            <div class="document-analysis-block">
                <div class="study-head-dir">
                    <div class="rde-row head-row">
                        <div class="team-mem-row head-width">
                            <i class="fas fa-tag s-icon-size"></i>
                            <span><h5 class="study-details">Study Type</h5></span>
                        </div>
                        <div class="add-user-block" >
                            <div class="study-flag-radiobuttons">
                                <div *ngFor="let flagOption of engagementFlagOptions.options">
                                    <label class="chkbox-container">{{flagOption.value}}
                                        <input type="radio" name="selectFlag" [checked]="studyFlagOptionId==flagOption.id"
                                            (change)="flagOptionClick(flagOption.id)">
                                        <span class="chk-checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="study-detail-block">
                <div class="rde-row head-row">
                    <i class="fas fa-layer-group s-icon-size"></i> <span>
                        <h5 class="study-details">Study Details</h5>
                    </span>
                </div>
                <div class="input-field-block">
                    <div class="rde-row">
                        <div class="col-6">
                            <div class="hcne-kpmgClients input-with-icon">
                                <label for="hcne-clients">
                                    <i class="far fa-asterisk star-style"></i> Client Name
                                    <span *ngIf="f.clientName.errors && f.clientName.touched && !isClientSelected">
                                        <span class="required-error"> (required)</span>
                                    </span>
                                    <ng-container *ngIf="!isClientMode">
                                        <div class="input-elm">
                                            <input id="client-name"
                                                class="black-input opposite-colors clients-autocomplete"
                                                [ngClass]="{'ng-invalid' :  (f.clientName.touched || f.clientName.dirty)}"
                                                placeholder="Search client name" type="text"
                                                no-special-chars="#!$%^<>+=" required
                                                (keyup)="onClientNameChanged($event.target.value)"
                                                [kpmgUiTypeahead]="searchExistingClients" [resultTemplate]="ct"
                                                [editable]="true" [inputFormatter]="clientFormatter"
                                                (blur)="showClientUsers(f.clientName.value)"  #custSearch
                                                (selectItem)="onClientSelected($event)" formControlName="clientName">
                                            <span class="search-icon"><i class="fas fa-search"></i></span>
                                        </div>
                                        <ng-template #ct let-c="result" let-t="term">
                                            <kpmg-ui-highlight class="create-engagement-typeahead"
                                                [result]="c.clientName" [term]="t">
                                            </kpmg-ui-highlight>&nbsp;
                                        </ng-template>
                                    </ng-container>
                                    <ng-container *ngIf="isClientMode">
                                        <input id="client-name" class="black-input opposite-colors clients-autocomplete"
                                            [ngClass]="{'ng-invalid' :  (f.clientName.touched || f.clientName.dirty)}"
                                            required (keyup)="onClientNameChanged($event.target.value)"
                                            placeholder="Client Name" type="text" no-special-chars="#!$%^<>+="
                                            [(ngModel)]="engagementClient" (blur)="showClientUsers(f.clientName.value)"
                                            formControlName="clientName">
                                    </ng-container>
                                </label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="rde-row ignore-col">
                                <div class="col-6 no-padding width-40">
                                    <label for="hcne-startDate">
                                        <i class="far fa-asterisk star-style"></i> TY Start Date
                                        <span *ngIf="this.isStartDateRequired" class="required-error">(required)

                                        </span>
                                        <span class="input-group startdate-input">
                                            <input type="text" class="black-input opposite-colors engagement-datepicker"
                                                [ngClass]="{'ng-invalid': startDateError}" placeholder="MM/DD/YYYY"
                                                [maxDate]="maxDate" bsDatepicker
                                                [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                                (bsValueChange)="setStartDate($event)"
                                                formControlName="engagementStartDate" no-special-chars="!$%^<>+='"
                                                #dpStart="bsDatepicker" (focus)="onfocStartDate()" />
                                            <span class="input-group-append cal-icon" (click)="openDatePickerStart()">
                                                <i class="fa fa-calendar-alt create-datepic"></i>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                                <div class="col-6 no-padding width-40">
                                    <label for="hcne-endDate">
                                        TY End Date
                                        <span class="input-group enddate-input">
                                            <input type="text" class="black-input opposite-colors"
                                                [ngClass]="{'ng-invalid': startDateError}" [maxDate]="maxDate"
                                                [minDate]="minDate" placeholder="MM/DD/YYYY" bsDatepicker
                                                [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                                (bsValueChange)="setEndDate($event)" formControlName="engagementEndDate"
                                                no-special-chars="!$%^<>+='" #dpEnd="bsDatepicker"
                                                (focus)="onfocEndDate()" style="opacity: 1;">
                                            <span class="input-group-append cal-icon" (click)="openDatePickerEnd()">
                                                <i class="fa fa-calendar-alt create-datepic"></i>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                                <div class="form-error-sign" *ngIf="startDateError">
                                    <p>Start Date cannot be later than End Date</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rde-row">
                        <div class="col-6">
                            <div class="hcne-engagementName mt-2 no-padding">
                                <label for="hcne-engagementName">
                                    <i class="far fa-asterisk star-style"></i> Study Name
                                    <span
                                        *ngIf="f.engagementName.errors && (f.engagementName.touched || f.engagementName.dirty)">
                                        <span class="required-error"
                                            *ngIf="f.engagementName.errors.required">(required)</span>
                                    </span>
                                    <input id="engagement-name" class="black-input opposite-colors"
                                        placeholder="Required" type="text" no-special-chars="!$%^<>+='"
                                        (blur)="trimSpecialChar('engagementName');" formControlName="engagementName"
                                        required (input)="onEngagementNameChanged($event.target.value)" />
                                </label>
                            </div>

                            <div class="form-error-sign" *ngIf="engagementNameError">
                                <p>Study name is already in use.</p>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="hcne-engagementNumber mt-2 no-padding">
                                <label for="hcne-engagementNumber">
                                    <i class="far fa-asterisk star-style"></i> Engagement Number
                                    <span
                                        *ngIf="f.engagementNumber.errors && (f.engagementNumber.touched || f.engagementNumber.dirty)">
                                        <span class="required-error"
                                            *ngIf="f.engagementNumber.errors.required">(required)</span>
                                    </span>
                                    <input id="eng-number" class="black-input opposite-colors" placeholder="Required"
                                        type="text" no-special-chars="#!$%^<>+='"
                                        (blur)="trimSpecialChar('engagementNumber');" formControlName="engagementNumber"
                                        required [ngClass]="{'ng-invalid': engagementNumberError}"
                                        (input)="onEngagementNumberChanged($event.target.value)" />
                                </label>
                            </div>
                            <div class="form-error-sign" *ngIf="engagementNumberError">
                                <p>Engagement Number is already in use.</p>
                            </div>
                            <div class="form-error-sign"
                                *ngIf="f.engagementNumber.errors && !f.engagementNumber.errors.required">
                                <p>Alphanumeric Characters Only</p>
                            </div>
                        </div>
                    </div>

                    <div class="rde-row">
                        <div class="col-6">
                            <div class="hcne-engagementName mt-2">
                                <label for="">
                                    <i class="far fa-asterisk star-style"></i> Engagement Manager

                                    <div class="input-elm">
                                        <input class="black-input opposite-colors kpmg-user-autocomplete"
                                            placeholder="Enter a KPMG User Name" type="text"
                                            no-special-chars="#!$%^<>+="
                                            [kpmgUiTypeahead]="searchEngagementManagerStream" [resultTemplate]="rt"
                                            [editable]="false" [inputFormatter]="kpmgUserFormatter"
                                            (keydown)="searchKPMG(true)"
                                            (selectItem)="onEngagementManagerSelect($event)">
                                        <span class="search-icon"><i class="fas fa-search"></i></span>
                                    </div>
                                    <ng-template #rt let-r="result" let-t="term">
                                        <kpmg-ui-highlight *ngIf="engagementManagerKPMGUser"
                                            class="create-engagement-typeahead"
                                            [innerHtml]='finalEngagementManagerstrKPMG' [term]="t">
                                        </kpmg-ui-highlight>
                                        <kpmg-ui-highlight *ngIf="!engagementManagerKPMGUser" [title]="r.userName"
                                            class="create-engagement-typeahead" [result]="r.displayName" [term]="t">
                                        </kpmg-ui-highlight>&nbsp;

                                    </ng-template>
                                </label>
                            </div>

                            <div *ngIf="engagementManagerSelected && engagementManagerSelected.length > 0" class="mt-2">
                                <ngx-datatable
                                    class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                    [rows]="engagementManagerSelected" [headerHeight]="0" [rowHeight]="35"
                                    [ngStyle]="{'height': engagementManagerSelected.length * 45 +'px' }">
                                    <ngx-datatable-column [width]="30">
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            <button class="link-button" (click)="removeEngagementManagerSelected(row)">
                                                <i class="fas fa-times cross-i-style"></i>
                                            </button>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column prop="name" [width]="250">
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            {{row.displayName}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                            </div>
                            <div *ngIf="noResultflag">
                                <div>
                                    user is not found.
                                </div>
                                <div class="add-user-link">Add this user</div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="hcne-engagementNumber mt-2 no-padding">
                                <label for="">
                                    <i class="far fa-asterisk star-style"></i> Engagement Partner

                                    <div class="input-elm">
                                        <input class="black-input opposite-colors kpmg-user-autocomplete"
                                            placeholder="Enter a KPMG User Name" type="text"
                                            no-special-chars="#!$%^<>+="
                                            [kpmgUiTypeahead]="searchEngagementPartnerStream" [resultTemplate]="eprt"
                                            [editable]="false" [inputFormatter]="kpmgUserFormatter"
                                            (keydown)="searchKPMG(true)"
                                            (selectItem)="onEngagementPartnerSelect($event)">
                                        <span class="search-icon"><i class="fas fa-search"></i></span>
                                    </div>
                                    <ng-template #eprt let-r="result" let-t="term">
                                        <kpmg-ui-highlight *ngIf="engagementPartnerKPMGUser"
                                            class="create-engagement-typeahead" [title]="r.userName"
                                            [innerHtml]='finalEngagementPartnerstrKPMG' [term]="t">
                                        </kpmg-ui-highlight>
                                        <kpmg-ui-highlight *ngIf="!engagementPartnerKPMGUser" [title]="r.userName"
                                            class="create-engagement-typeahead" [result]="r.displayName" [term]="t">
                                        </kpmg-ui-highlight>&nbsp;

                                    </ng-template>

                                </label>
                            </div>
                            <div *ngIf="engagementPartnerSelected && engagementPartnerSelected.length > 0" class="mt-2">
                                <ngx-datatable
                                    class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                    [rows]="engagementPartnerSelected" [headerHeight]="0" [rowHeight]="35"
                                    [ngStyle]="{'height': engagementPartnerSelected.length * 45 +'px' }">
                                    <ngx-datatable-column [width]="30">
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            <button class="link-button" (click)="removeEngagementPartnerSelected(row)">
                                                <i class="fas fa-times cross-i-style"></i>
                                            </button>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column prop="name" [width]="250">
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            {{row.displayName}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                            </div>
                            <div *ngIf="noResultflag">
                                <div>
                                    User could not be found.
                                </div>
                                <div class="add-user-link">Add this user</div>
                            </div>
                        </div>
                    </div>

                    <div class="rde-row">
                        <div class="col-6">
                            <div class="hcne-engagementNumber mt-2">
                                <label for="hcne-engagementNumber">
                                    <i class="star-style"></i>
                                    <div class="input-elm">
                                        <label class="wrap">
                                            <span class="col-4 p-0">Tax Year: </span>
                                            <input id="engagement-name"
                                                class="black-input opposite-colors no-input col-8 no-padding"
                                                type="text" no-special-chars="#!$%^<>+='" [value]="taxYear"
                                                readonly="readonly" />
                                        </label>

                                    </div>

                                </label>
                            </div>

                        </div>
                        <div class="col-6">
                            <div class="hcne-engagementName mt-2 no-padding">
                                <label for="hcne-engagementName">
                                    <i class="far fa-asterisk star-style"></i> Email Reminders
                                    <span
                                        *ngIf="f.engagementName.errors && (f.engagementName.touched || f.engagementName.dirty)">
                                        <span class="required-error"
                                            *ngIf="f.engagementName.errors.required">(required)</span>
                                    </span>
                                    <div class="input-elm">
                                        <custom-dropdown [selectText]="emailReminderText"
                                            [options]="emailReminderOptions"
                                            (optionSelectedEvent)="onEmailFrequencySelected($event)">
                                        </custom-dropdown>
                                        <div class="form-warning-sign" *ngIf="f.engagementEmailFrequency.value===0">
                                            <p class="mt-0">* Email reminder is disabled</p>
                                        </div>
                                        <div class="form-error-sign" *ngIf="!f.engagementEmailFrequency.valid">
                                            <p class="mt-0">Email Reminder Frequency should be between 0 and 10.</p>
                                        </div>
                                    </div>
                                </label>
                            </div>

                        </div>
                    </div>

                    <div class="hours-block rde-row">
                        <div class="col-6">
                                    <label>
                                        Total Hours
                                        <div>
                                            <input class="black-input opposite-colors" min="0" max="3500" value="2096" formControlName="totalHours" type="number" onlyNumber>
                                        </div>
                                    </label>
                        </div>
                        <div class="col-6">
                                    <label>
                                        Standard Non-Working Hours
                                        <div>
                                            <input class="black-input opposite-colors" min="0" max="2096" value="120" formControlName="standardNonWorkingHours" type="number" onlyNumber>
                                        </div>
                                    </label>
                        </div>
                        
                            <div class="col-6 sme-checkbox-lable">
                            <label class="datatable-checkbox parent-checkbox kpmg-checkbox">
                                <input type="checkbox" (change)="allowSMEsToAddNewProjectsEvent($event)" />
                                <span class ="checkbox-lable-padding">Allow SME to add new Projects, Activities, NQAs and NWT inside Time survey.</span>
                            </label>
                        </div>
                        <div class="col-6 sme-checkbox-lable">
                            <label class="datatable-checkbox parent-checkbox kpmg-checkbox">
                                <input type="checkbox" (change)="allowSMEsToAddNewEmployeesEvent($event)" />
                                <span class ="checkbox-lable-padding">Allow SME to add/remove new Employees inside Time survey.</span>
                            </label>
                        </div>
                </div>   
                         
                    <div class="col-6 Qre-block">
                        <div class="rde-row ignore-col">
                            <div class="col-6 no-padding width-40">
                        <label for="hcne-startDate">
                            Prior Year QRE
                            <div>
                                <input class="black-input opposite-colors" (keyup)="_keyUp($event)"  formControlName="priorYearQre" type="number" >
                            </div>
                        </label>
                    </div>
                    <div class="col-6 no-padding width-40">
                        <label for="hcne-endDate">
                            Estimated QRE
                            <div>
                                <input class="black-input opposite-colors" (keyup)="_keyUp($event)" formControlName="estimatedQre" type="number" >
                            </div>
                        </label>
                    </div>
                </div> 
            </div>
        </div>
    </div>

            <div class="team-members-block">
                <div class="rde-row head-row">
                    <div class="team-mem-row">
                        <i class="fas fa-user-friends s-icon-size"></i> <span>
                            <h5 class="study-details">Team Members</h5>
                        </span>
                    </div>
                    <div class="col-6">
                        <!-- <div class="add-user-link" (click)="addUserClick()"><i class="far fa-plus"></i> Add new user</div> -->
                    </div>
                </div>
                <div class="rde-row add-user-sec">
                    <div class="col-6">
                        <div class="add-user-block">
                            <label for="hcne-clients">Add KPMG Users</label>
                            <div class="hcne-kpmg-users">
                                <div class="hcne-kpmgUsers input-with-icon mt-2">
                                    <div class="input-elm">
                                        <input class="black-input opposite-colors kpmg-user-autocomplete"
                                            placeholder="Enter a KPMG User Name" type="text"
                                            no-special-chars="#!$%^<>+=" [kpmgUiTypeahead]="searchUserStream"
                                            [resultTemplate]="addkpmgrt" [editable]="false"
                                            [inputFormatter]="kpmgUserFormatter" (keydown)="searchKPMG(true)"
                                            (selectItem)="onKPMGUserSelect($event)">
                                        <span class="search-icon"><i class="fas fa-search"></i></span>
                                    </div>
                                    <ng-template #addkpmgrt let-r="result" let-t="term">
                                        <kpmg-ui-highlight *ngIf="engagementAddKPMGUser"
                                            class="create-engagement-typeahead" [innerHtml]='finalAddKPMGUserstrKPMG'
                                            [term]="t">
                                        </kpmg-ui-highlight>
                                        <kpmg-ui-highlight *ngIf="!engagementAddKPMGUser" [title]="r.userName"
                                            class="create-engagement-typeahead" [result]="r.displayName" [term]="t">
                                        </kpmg-ui-highlight>&nbsp;

                                    </ng-template>
                                </div>

                                <div *ngIf="kpmgUsersSelected.length > 0" class="mt-2">
                                    <ngx-datatable
                                        class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                        [rows]="kpmgUsersSelected" [headerHeight]="0" [rowHeight]="35"
                                        [ngStyle]="{'height': kpmgUsersSelected.length * 45 +'px' }">
                                        <ngx-datatable-column [width]="30">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                <button class="link-button" (click)="removeKPMGUser(row)">
                                                    <i class="fas fa-times cross-i-style"></i>
                                                </button>
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column prop="name" [width]="250">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{row.displayName}}
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                                </div>
                                <div *ngIf="noResultflag">
                                    <div>
                                        user is not found.
                                    </div>
                                    <div class="add-user-link">Add this user</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="add-user-block">
                            <label for="hcne-clients">Add Client Managers</label>
                            <div class="hcne-kpmg-clientusers">
                                <div class="hcne-kpmgUsers input-with-icon mt-2">
                                    <div class="input-elm">
                                        <input class="black-input opposite-colors kpmg-user-autocomplete"
                                            [ngClass]="{disabledText: !clientUsers}"
                                            placeholder="Enter a Client User Name" type="text"
                                            no-special-chars="#!$%^<>+=" [kpmgUiTypeahead]="searchUserStream"
                                            [resultTemplate]="rt" [editable]="false"
                                            [inputFormatter]="clientUserFormatter" (keydown)="searchKPMG(false)"
                                            (selectItem)="onClientUserSelect($event)" [disabled]="!clientUsers">
                                        <span class="search-icon"><i class="fas fa-search"></i></span>
                                    </div>
                                    <ng-template #rt let-r="result" let-t="term">
                                        <kpmg-ui-highlight [title]="r.userName" class="create-engagement-typeahead"
                                            [result]="r.displayName" [term]="t">
                                        </kpmg-ui-highlight>&nbsp;
                                    </ng-template>
                                </div>

                                <div *ngIf="clientUsersSelected.length > 0" class="mt-2">
                                    <ngx-datatable
                                        class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                        [rows]="clientUsersSelected" [headerHeight]="0" [rowHeight]="35"
                                        [ngStyle]="{'height': clientUsersSelected.length * 45 +'px' }">
                                        <ngx-datatable-column [width]="30">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                <button class="link-button" (click)="removeClientUser(row)">
                                                    <i class="fas fa-times cross-i-style"></i>
                                                </button>
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column prop="name" [width]="250">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{row.displayName}}
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <footer class="endFormSubmit info-tile">
        <!-- <kpmg-button (click)="createEngagement()" buttonType="primary" [isDisabled]="(!targetForm.valid || startDateError || engagementNumberError || engagementNameError) && !isDisabled" text="Create Study" ></kpmg-button> -->
        <button type='button' class="btn btn-success" (click)="createStudy()"
            [disabled]="(!targetForm.valid || startDateError || engagementNumberError || engagementNameError || engagementManagerSelectedId === 0 || engagementPartnerSelectedId === 0 || studyFlagOptionId === 0) && !isDisabled">
            Create Study
        </button> &nbsp;
        <!-- <kpmg-button buttonType='flat' text="Cancel"
            (click)="onCancel()"></kpmg-button> -->
        <button type='button' class="btn kpmg-button--flat" (click)="onCancel()">Cancel</button>
    </footer>
</form>
<!-- <right-side-drawer (mandatoryindicator)="confirm($event)"></right-side-drawer> -->
